import * as React from "react";
import { useTranslation } from "react-i18next";
import { BrandMark } from "./brand-mark";
import { NavSectionLabel } from "./nav-section-label";
import { cn } from "@/lib/utils";

export interface SidebarSection {
  label: string;
  items: React.ReactNode;
}

export interface SidebarProps {
  sections: SidebarSection[];
  className?: string;
}

export function Sidebar({ sections, className }: SidebarProps) {
  const { t } = useTranslation();
  return (
    <aside
      style={{ viewTransitionName: "vroom-sidebar" }}
      className={cn(
        "flex w-56 shrink-0 flex-col gap-1 border-r border-line bg-surface-1 py-3 [view-transition-name:vroom-sidebar]",
        className,
      )}
    >
      <div className="px-3 pb-3">
        <div className="flex items-center gap-2">
          <BrandMark />
          <span className="font-semibold text-ink-900">{t("common.brand.label")}</span>
        </div>
      </div>
      {sections.map((s) => (
        <div key={s.label} className="px-1">
          <NavSectionLabel>{s.label}</NavSectionLabel>
          <div className="grid gap-0.5">{s.items}</div>
        </div>
      ))}
    </aside>
  );
}
